import { Component, ViewChild, OnInit, Input, Output, EventEmitter, Optional } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { FormControl } from '@angular/forms';
import { MdInputDirective, Dir } from '@angular/material';
import'rxjs/add/operator/debounceTime';
import'rxjs/add/operator/skip';
export class TdSearchInputComponent implements OnInit {

   _input: MdInputDirective;

  value: string;
/**
 * showUnderline?: boolean
 * Sets if the input underline should be visible. Defaults to 'false'.
 */
showUnderline: boolean = false;
/**
 * debounce?: number
 * Debounce timeout between keypresses. Defaults to 400.
 */
debounce: number = 400;
/**
 * placeholder?: string
 * Placeholder for the underlying input component.
 */
placeholder: string;
/**
 * searchDebounce: function($event)
 * Event emitted after the [debounce] timeout.
 */
onSearchDebounce: EventEmitter<string> = new EventEmitter<string>();
/**
 * search: function($event)
 * Event emitted after the key enter has been pressed.
 */
onSearch: EventEmitter<string> = new EventEmitter<string>();
/**
 * clear: function()
 * Event emitted after the clear icon has been clicked.
 */
onClear: EventEmitter<void> = new EventEmitter<void>();
/**
 * blur: function()
 * Event emitted after the blur event has been called in underlying input.
 */
onBlur: EventEmitter<void> = new EventEmitter<void>();
/**
 * @return {?}
 */
get isRTL(): boolean {
    if (this._dir) {
      return this._dir.dir === 'rtl';
    }
    return false;
  }
/**
 * @param {?} _dir
 */
constructor(
private _dir: Dir) {
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this._input._ngControl.valueChanges
      .skip(1) // skip first change when value is set to undefined
      .debounceTime(this.debounce)
      .subscribe((value: string) => {
        this._searchTermChanged(value);
      });
  }
/**
 * Method to focus to underlying input.
 * @return {?}
 */
focus(): void {
    this._input.focus();
  }
/**
 * @return {?}
 */
handleBlur(): void {
    this.onBlur.emit(undefined);
  }
/**
 * @param {?} event
 * @return {?}
 */
stopPropagation(event: Event): void {
    event.stopPropagation();
  }
/**
 * @param {?} event
 * @return {?}
 */
handleSearch(event: Event): void {
    this.stopPropagation(event);
    this.onSearch.emit(this.value);
  }
/**
 * @return {?}
 */
clearSearch(): void {
    this.value = '';
    this.onClear.emit(undefined);
  }
/**
 * @param {?} value
 * @return {?}
 */
private _searchTermChanged(value: string): void {
    this.onSearchDebounce.emit(value);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.css' ],
  animations: [
    trigger('searchState', [
      state('hide-left', style({
        transform: 'translateX(-150%)',
        display: 'none',
      })),
      state('hide-right', style({
        transform: 'translateX(150%)',
        display: 'none',
      })),
      state('show',  style({
        transform: 'translateX(0%)',
        display: 'block',
      })),
      transition('* => show', animate('200ms ease-in')),
      transition('show => *', animate('200ms ease-out')),
    ]),
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Dir, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_input': [{ type: ViewChild, args: [MdInputDirective, ] },],
'showUnderline': [{ type: Input, args: ['showUnderline', ] },],
'debounce': [{ type: Input, args: ['debounce', ] },],
'placeholder': [{ type: Input, args: ['placeholder', ] },],
'onSearchDebounce': [{ type: Output, args: ['searchDebounce', ] },],
'onSearch': [{ type: Output, args: ['search', ] },],
'onClear': [{ type: Output, args: ['clear', ] },],
'onBlur': [{ type: Output, args: ['blur', ] },],
};
}

function TdSearchInputComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdSearchInputComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdSearchInputComponent.ctorParameters;
/** @type {?} */
TdSearchInputComponent.propDecorators;
/** @type {?} */
TdSearchInputComponent.prototype._input;
/** @type {?} */
TdSearchInputComponent.prototype.value;
/**
 * showUnderline?: boolean
 * Sets if the input underline should be visible. Defaults to 'false'.
 * @type {?}
 */
TdSearchInputComponent.prototype.showUnderline;
/**
 * debounce?: number
 * Debounce timeout between keypresses. Defaults to 400.
 * @type {?}
 */
TdSearchInputComponent.prototype.debounce;
/**
 * placeholder?: string
 * Placeholder for the underlying input component.
 * @type {?}
 */
TdSearchInputComponent.prototype.placeholder;
/**
 * searchDebounce: function($event)
 * Event emitted after the [debounce] timeout.
 * @type {?}
 */
TdSearchInputComponent.prototype.onSearchDebounce;
/**
 * search: function($event)
 * Event emitted after the key enter has been pressed.
 * @type {?}
 */
TdSearchInputComponent.prototype.onSearch;
/**
 * clear: function()
 * Event emitted after the clear icon has been clicked.
 * @type {?}
 */
TdSearchInputComponent.prototype.onClear;
/**
 * blur: function()
 * Event emitted after the blur event has been called in underlying input.
 * @type {?}
 */
TdSearchInputComponent.prototype.onBlur;
/** @type {?} */
TdSearchInputComponent.prototype._dir;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
